<template>
    <div class="context">
        <component :is="component_id"
                   @changeTopTab="switchModule"
                   :ref="component_id"></component>
    </div>
</template>

<script>
    import SDLCView from "./SDLC"
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "",
        components: {
            SDLCView,
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapState('comInformationData', {
                component_id: 'component_id'
            })
        },
        methods: {
            switchModule(id) {

            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>